import { render, staticRenderFns } from "./riwayatPendidikanFormal.vue?vue&type=template&id=ca01f3d0&scoped=true&"
import script from "./riwayatPendidikanFormal.vue?vue&type=script&lang=js&"
export * from "./riwayatPendidikanFormal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca01f3d0",
  null
  
)

export default component.exports